import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { DeliveriesInitialState } from './types';

const DELIVERIES_INITIAL_STATE: DeliveriesInitialState = {
  selectedDeliveryId: '',
};

const deliveriesSlice = createSlice({
  name: 'deliveries',
  initialState: DELIVERIES_INITIAL_STATE,
  reducers: {
    setSelectedDeliveryId(state, action: PayloadAction<string>) {
      state.selectedDeliveryId = action.payload;
    },
  },
});

export const { setSelectedDeliveryId } = deliveriesSlice.actions;

export const deliveriesReducer = deliveriesSlice.reducer;
